/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from '@reducers/types';
import { AnyAction } from 'redux';
import { UniveresalTrackerGroup } from '../types/universalTracker';

type State =
  ReduxStateLoadable<UniveresalTrackerGroup[], UniveresalTrackerGroup[]>
  & { initiativeId?: string };

const getDefaultState = (): State => ({
  data: [],
  loaded: false,
  errored: false,
  errorMessage: '',
  initiativeId: undefined
});

const universalTrackerGroups = (
  state = getDefaultState(),
  action: AnyAction,
): State => {

  switch (action.type) {

    case actionTypes.LOADING_UNIVERSALTRACKERGROUPS:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_UNIVERSALTRACKERGROUPS:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.NO_DATA_UNIVERSALTRACKERGROUPS:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.LOADED_UNIVERSALTRACKERGROUPS:
      return {
        ...state,
        initiativeId: action.initiativeId,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default universalTrackerGroups;
